import { backgroundColor, borders, boxShadow, layout, opacity, overflow, positioning, space, typography, display } from '../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { flexboxes } from './system.js';

var props = [];
var allProps = props.concat(backgroundColor.meta.props, borders.meta.props, boxShadow.meta.props, flexboxes.meta.props, layout.meta.props, opacity.meta.props, overflow.meta.props, positioning.meta.props, space.meta.props, typography.meta.props, display.meta.props);
var shouldForwardProp = function (prop) {
  return !allProps.includes(prop);
};

export { shouldForwardProp };
//# sourceMappingURL=should-forward-prop.js.map
